export const sortDepartement = (a, b) => {
  // `|| ''` : certaines marques ont variant/name/state null (donnees CS-Cart
  // incompletes) -> null.normalize() crashait le comparateur, faisait echouer
  // formatAllBrands et vidait toute la page Marques. Valeur par defaut = '' (tri en tete).
  const normalize = v =>
    (v?.name || v?.state || v?.variant || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()

  const aVal = normalize(a)
  const bVal = normalize(b)

  if (aVal > bVal) return 1
  if (aVal < bVal) return -1
  return 0
}
const getSortDepartement = (divisions, values) => {
  // on ne doit pas travailler sur le pointeur d'origine, alors on copie le tableau
  const subDivisions = [...(divisions.find(d => d.country_code === values?.country)?.states || [])]

  return subDivisions.sort(sortDepartement)
}

export default getSortDepartement
